import Api from "../utils/api";


export default class AuthApi extends Api {
    private static PREFIX = "/api/v1/auth";

    login = async (username: string, password: string) => {
        return (await this.axios.post(`${AuthApi.PREFIX}/login`, { username, password })).data;
    }
}